//src>subabase.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://mrvjbdvkfzgsvtvtrcrb.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1ydmpiZHZrZnpnc3Z0dnRyY3JiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjEzMzUxODYsImV4cCI6MjAzNjkxMTE4Nn0.7PDyWYs3rYjWD03pM5eg56diJB1xf-NnXCOYuNcTbtI";
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};
